//引入http.js文件
import http from "./http.js";
import cfg from "@/config/index";

//设置个对象，就不用一个个export了，直接export对象
let api = {};
/**
 * 图片上传ZIP
 * @param {*} params
 * @returns
 */
api.uploadImgZip = function (params) {
  return http.postfile("/api/sysFileInfo/uploadImgZip", params);
};
/**
 * 用户列表
 * @param {*} params
 * @returns
 */
api.user_getlist = function (params) {
  return http.get("/api/user/getlist", params);
};
/**
 *用户获取
 * @param {*} params
 * @returns
 */
api.user_get = function (params) {
  return http.get("/api/user/get", params);
};
/**
 * 分页用户
 * @param {*} params
 * @returns
 */
api.user_getpage = function (params) {
  return http.get("/api/user/getpage", params);
};
/**
 * OpenAI账户列表
 * @param {*} params
 * @returns
 */
api.openAIAccount_getlist = function (params) {
  return http.get("/api/openAIAccount/getlist", params);
};
/**
 *OpenAI账户获取
 * @param {*} params
 * @returns
 */
api.openAIAccount_get = function (params) {
  return http.get("/api/openAIAccount/get", params);
};
/**
 * 分页OpenAI账户
 * @param {*} params
 * @returns
 */
api.openAIAccount_getpage = function (params) {
  return http.get("/api/openAIAccount/getpage", params);
};
/**
 * 资产列表
 * @param {*} params
 * @returns
 */
api.asset_getlist = function (params) {
  return http.get("/api/asset/getlist", params);
};
/**
 *资产获取
 * @param {*} params
 * @returns
 */
api.asset_get = function (params) {
  return http.get("/api/asset/get", params);
};
/**
 * 分页资产
 * @param {*} params
 * @returns
 */
api.asset_getpage = function (params) {
  return http.get("/api/asset/getpage", params);
};
/**
 * 对话列表
 * @param {*} params
 * @returns
 */
api.conversation_getlist = function (params) {
  return http.get("/api/conversation/getlist", params);
};
/**
 *对话获取
 * @param {*} params
 * @returns
 */
api.conversation_get = function (params) {
  return http.get("/api/conversation/get", params);
};
/**
 * 分页对话
 * @param {*} params
 * @returns
 */
api.conversation_getpage = function (params) {
  return http.get("/api/conversation/getpage", params);
};
/**
 * 反馈列表
 * @param {*} params
 * @returns
 */
api.feedback_getlist = function (params) {
  return http.get("/api/feedback/getlist", params);
};
/**
 *反馈获取
 * @param {*} params
 * @returns
 */
api.feedback_get = function (params) {
  return http.get("/api/feedback/get", params);
};
/**
 * 分页反馈
 * @param {*} params
 * @returns
 */
api.feedback_getpage = function (params) {
  return http.get("/api/feedback/getpage", params);
};
/**
 * 获取会话
 * @param {*} params
 * @returns
 */
api.get_session = function (params) {
  return http.post("/api/user/getsession", params);
};

/**
 * 提交反馈
 * @param {*} params
 * @returns
 */
api.feedback_submit = function (params) {
  return http.post("/api/feedback/submit", params);
};

/**
 * 获取用户信息
 * @param {*} params
 * @returns
 */
api.getUserInfo = function (params) {
  return http.get("/api/user/getUserInfo", params);
};

/**
 * 设置用户信息
 * @param {*} params
 * @returns
 */
 api.setAccountPwd = function (params) {
  return http.post("/api/user/SetAccountPwd", params);
};

/**
 * 更新用户信息
 * @param {*} params
 * @returns
 */
api.updateUserByClient = function (params) {
  return http.post("/api/user/updateUserByClient", params);
};

api.uploadUrl = cfg.BASE_URL + "/api/sysFileInfo/upload";
/**
 * 获取文件url
 * @param {*} id
 * @returns
 */
api.getFileUrl = function (id) {
  return `${cfg.BASE_URL}/api/sysFileInfo/preview?id=${id}`;
};

/**
 * 收藏
 * @param {*} params
 * @returns
 */
api.collect = function (params) {
  return http.post("/api/UserCollect/collect", params);
};

/**
 * 收藏列表
 * @param {*} params
 * @returns
 */
api.collectList = function (params) {
  return http.post("/api/UserCollect/collectList", params);
};

/**
 * 收藏删除
 * @param {*} params
 * @returns
 */
api.collectDel = function (params) {
  return http.post("/api/UserCollect/collectDel", params);
};

/**
 * 创建订单
 * @param {*} params
 * @returns
 */
api.createOrder = function (params) {
  return http.post("/api/QuotaOrder/Create", params);
};

/**
 * 获取订单状态
 * @param {*} params
 * @returns
 */
api.getState = function (params) {
  return http.get("/api/QuotaOrder/GetState", params);
};

/**
 * 获取订单
 * @param {*} params
 * @returns
 */
api.getOrders = function (params) {
  return http.get("/api/QuotaOrder/GetOrders", params);
};

/**
 * 获取提示列表
 * @param {*} params
 * @returns
 */
// api.getPromptList = function (params) {
//   return http.get("/api/PromptTemplate/GetList", params);
// };
api.getPromptList = function (params) {
  return http.get("/api/PromptTemplate/GetListByClass", params);
};

/**
 * 获取创建图片提示列表
 * @param {*} params
 * @returns
 */
api.getCreateImgPromptList = function (params) {
  return http.get("/api/promptdalle/getlist", params);
};
/**
 * 获取提示列表按分类
 * @param {*} params
 * @returns
 */
api.getListByClass = function (params) {
  return http.get("/api/PromptTemplate/GetListByClass", params);
};

/**
 * 获取用户根据机器id
 * @param {*} params
 * @returns
 */
api.getUserByMachineId = function (params) {
  return http.get("/api/User/getUserByMachineId", params);
};

/**
 * 修改密码
 * @param {*} params
 * @returns
 */
api.changePwd = function (params) {
  return http.post("/api/User/changePwd", params);
};

/**
 * 获取时长商品
 * @param {*} params
 * @returns
 */
api.GetGoodsList = function (params) {
  return http.get("/api/Goods/GetList", params);
};

/**
 * 注册
 * @param {*} params
 * @returns
 */
api.Register = function (params) {
  return http.post("/api/user/Register", params);
};

/**
 * 发送验证码
 * @param {*} params
 * @returns
 */
api.SendCode = function (params) {
  return http.post("/api/user/SendCode", params);
};

/**
 * 忘记密码
 * @param {*} params
 * @returns
 */
api.ForgetPwd = function (params) {
  return http.post("/api/user/ForgetPwd", params);
};

/**
 * 获取微信授权url
 * @param {*} params
 * @returns
 */
api.GetWXAuthUrl = function (params) {
  return http.get("/api/user/GetWXAuthUrl", params);
};

/**
 * 获取微信授权url
 * @param {*} params
 * @returns
 */
api.SetOpenId = function (params) {
  return http.post("/api/user/SetOpenId", params);
};


/**
 * 分页查询邀请记录
 * @param {*} params
 * @returns
 */
api.InviteRecord = function (params) {
  return http.get("/api/agentpromo/InviteRecord", params);
};

/**
 * 分页查询佣金记录
 * @param {*} params
 * @returns
 */
api.CommissionRecord = function (params) {
  return http.get("/api/agentpromo/CommissionRecord", params);
};

/**
 * 获取身份指令列表
 * @param {*} params
 * @returns
 */
api.GetSFZLList = function (params) {
  return http.get("/api/PromptTemplate/GetSFZLList", params);
};

/**
 * 导出对话记录
 * @param {*} params
 * @returns
 */
api.Export = function (params) {
  return http.post("/api/Conversation/Export", params);
};

/**
 * 导出对话记录
 * @param {*} params
 * @returns
 */
api.Export = function (params) {
  return http.post("/api/Conversation/Export", params);
};

/**
 * 同步对话记录
 * @param {*} params
 * @returns
 */
api.SyncChatHistory = function (params) {
  return http.post("/api/User/SyncChatHistory", params);
};

/**
 * 获取对话记录
 * @param {*} params
 * @returns
 */
api.GetChatHistory = function (params) {
  return http.get("/api/User/GetChatHistory", params);
};

/**
 * 获取OpenAI账户
 * @param {*} params
 * @returns
 */
api.GetOpenAIAccount = function (params) {
  return http.get("/api/OpenAIAccount/GetOpenAIAccount", params);
};

import httpgpt from "./httpgpt.js";
/**
 * 获取聊天完成
 * @param {*} params
 * @returns
 */
api.ChatCompletionFull = function (params) {
  return httpgpt.post("/api/conversation/ChatCompletionFull", params);
};

/**
 * 获取文本生成图片
 * @param {*} params
 * @returns
 */
 api.ChatCreateImage = function (params) {
  if(params.httpgpt)
    return httpgpt.post("/api/conversation/ChatCreateImage", params);
  else
    return http.post("/api/conversation/ChatCreateImage", params);
};

/**
 * 获取文本生成语音
 * @param {*} params
 * @returns
 */
api.ChatCreateSpeech = function (params) {
  if(params.httpgpt)
    return httpgpt.post("/api/conversation/ChatCreateSpeech", params);
  else
    return http.post("/api/conversation/ChatCreateSpeech", params);
};

/**
 * 获取AI助手列表
 * @param {*} params
 * @returns
 */
 api.GetAiassistantList = function (params) {
  return http.get("/api/aiassistant/getlist", params);
  // return httpgpt.get("/api/aiassistant/list", params);
};

/**
 * 获取快捷对话列表
 * @param {*} params
 * @returns
 */
 api.GetAiassistantuserList = function (params) {
  return http.get("/api/aiassistantuser/getlist", params);
};

/**
 * 删除快捷对话
 * @param {*} params
 * @returns
 */
 api.DelByAIAssistantId = function (params) {
  return http.post("/api/aiassistantuser/DelByAIAssistantId", params);
};

//export出这个对象
export default api;
